import { useCallback } from 'react';
import { toast } from 'react-toastify';
import useHttp from './useHttp';
import { useAuth } from '../context/authContext';

const cleanupRight = 'internalBooking:special:cleanupTestBookings';

export default function useTestBookingCleanup() {
  const { isLoading, sendRequest } = useHttp();
  const { getAuthHeaders } = useAuth();

  const fetchTestBookings = useCallback(
    async ({ page = 1, limit = 25, searchQuery = '' } = {}) => {
      try {
        const response = await sendRequest({
          url: '/api/v1/testBookingCleanup/bookings',
          method: 'GET',
          headers: getAuthHeaders(),
          params: { page, limit, searchQuery },
        });

        return {
          bookings: Array.isArray(response?.bookings) ? response.bookings : [],
          pagination: response?.pagination || { total: 0, page, limit, pages: 0 },
          testEmailAddresses: Array.isArray(response?.testEmailAddresses)
            ? response.testEmailAddresses
            : [],
        };
      } catch (error) {
        if (error.message !== 'INSUFFICIENT_RIGHTS') {
          toast.error('Fehler beim Laden der Testbuchungen');
        }
        throw error;
      }
    },
    [getAuthHeaders, sendRequest]
  );

  const cancelTestBooking = useCallback(
    async bookingId => {
      try {
        return await sendRequest({
          url: `/api/v1/testBookingCleanup/bookings/${bookingId}/cancel`,
          method: 'POST',
          headers: getAuthHeaders(),
          requiredRights: [cleanupRight],
        });
      } catch (error) {
        if (error.message !== 'INSUFFICIENT_RIGHTS') {
          toast.error('Fehler beim Stornieren der Testbuchung');
        }
        throw error;
      }
    },
    [getAuthHeaders, sendRequest]
  );

  return {
    isLoading,
    fetchTestBookings,
    cancelTestBooking,
  };
}
